import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DataTableComponent } from './data-table.component';
import { PriorityTemplateComponent } from './templates/priority-template/priority-template.component';
import { ScheduledTemplateComponent } from './templates/scheduled-template/scheduled-template/scheduled-template.component';

@NgModule({
  declarations: [DataTableComponent, PriorityTemplateComponent, ScheduledTemplateComponent],
  imports: [SharedModule],
  exports: [DataTableComponent, PriorityTemplateComponent, ScheduledTemplateComponent]
})
export class DataTableModule {}
